<div
  class="dialog"
  style="display: block; margin-top: 12px"
  #parentScroll
  [class.loading]="isAdding"
>
  <!-- <div> -->
  <owc-component-header
    class="header"
    [class.scrolled]="isScrolled"
    [class.loading]="isAdding"
  >
    <div class="mat-title" style="display: block">Attachments Modification</div>
  </owc-component-header>
  <div
    style="
      display: flex;
      position: relative;
      z-index: 1;
      justify-content: space-between;
      margin: 0px 10px 5px 10px;
    "
  >
    <owc-checkbox
      (change)="toggleSelectAll($event)"
      [checked]="
        selectedIds.size == allAttachments.length && allAttachments?.length > 0
      "
      [indeterminate]="
        selectedIds.size > 0 && selectedIds.size < allAttachments.length
      "
    >
      Select All
    </owc-checkbox>
    <div
      style="margin: 0px !important; padding: 0px !important; color: #0a41cc"
      *ngIf="allAttachments?.length > 0"
    >
      Selected: {{ selectedIds.size }} of {{ allAttachments.length }}
    </div>
    <owc-button (click)="deleteSelected()" [disabled]="selectedIds.size == 0">
      Delete
    </owc-button>
  </div>
  <owc-card oneCard class="card-list" style="width: 100%">
    <div class="card-body">
      <ng-container
        *ngIf="
          filteredGLobalAttachments &&
          filteredGLobalAttachments.length > 0 &&
          filteredGLobalAttachments[0].PIMID
        "
      >
        <div
          class="nd-files-list"
          *ngFor="let attachment of filteredGLobalAttachments; let i = index"
        >
          <div
            class="single-file"
            style="display: flex"
            style="margin: 8px 8px 8px 0"
          >
            <owc-checkbox
              [checked]="selectedIds.has(attachment.id)"
              (change)="onSelectionChange($event, i, attachment)"
            >
              <div class="info">
                <span class="name truncate-text" [title]="attachment.Title">
                  {{ attachment.Title }}
                </span>
                <span class="globalTag">Global</span>
              </div>
            </owc-checkbox>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="filteredLocalAttachments && filteredLocalAttachments.length > 0"
      >
        <div
          class="nd-files-list"
          *ngFor="let attachmentData of filteredLocalAttachments; let i = index"
        >
          <div
            class="single-file"
            style="display: flex"
            style="margin: 8px 8px 8px 0"
          >
            <owc-checkbox
              [checked]="selectedIds.has(attachmentData.id)"
              (change)="onSelectionChange($event, i, attachmentData)"
            >
              <div class="info">
                <span
                  class="name truncate-text"
                  [title]="attachmentData.FileName"
                >
                  {{ attachmentData.FileName }}
                </span>
                <span class="localTag">Local</span>
              </div>
            </owc-checkbox>
          </div>
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="allAttachments?.length == 0"
      style="
        color: red;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        margin-bottom: 35px;
      "
    >
      No attachment to delete
    </div>
  </owc-card>

  <div style="display: flex; margin: 15px; align-items: center">
    <hr
      style="
        width: 25%;
        display: block;
        height: 0px;
        text-decoration: dashed;
        color: black;
        margin-right: 0;
      "
    />
    <div style="margin: 0px 10px">OR</div>
    <hr
      style="
        width: 25%;
        display: block;
        height: 0px;
        text-decoration: dashed;
        color: black;
        margin-left: 0;
      "
    />
  </div>
  <div class="important-note" style="max-width: 45%">
    ℹ️
    <strong>Important: </strong>
    You can add
    {{
      11 - allAttachments?.length < 0 ? 0 : 11 - allAttachments?.length
    }}
    attachment(s).
  </div>
  <owc-card class="add-attachment" #scrollContainer>
    <dl-file-upload-multiple
      [fileUploadwithCheck]="'multiple'"
      [file_Input]="filesData"
    ></dl-file-upload-multiple>
  </owc-card>

  <div style="display: flex; justify-content: space-between">
    <div style="margin: 10px 10px 10px 10px">
      <owc-button (click)="cancelClicked()"> Cancel </owc-button>
    </div>
    <div style="display: flex">
      <owc-button
        style="margin: 10px 10px 10px 10px"
        [disabled]="uploadingFiles.length == 0"
        (click)="btnSendNotificationClicked()"
      >
        {{ isAdding ? 'Adding...' : 'Add' }}
      </owc-button>
    </div>
  </div>
</div>
